"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../../helpers/getContentType");
const entity_1 = require("../../type/entity");
const applySwitchToLatestCurriculumOfferCommand_1 = require("./applySwitchToLatestCurriculumOfferCommand");
const applySwitchToLatestOfferCommand_1 = require("./applySwitchToLatestOfferCommand");
function applySwitchToLatestContentCommand(command, user, content, childContents, states, enrolments) {
    let mutationPayload;
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.COURSE:
        case entity_1.ContentType.ILT:
        case entity_1.ContentType.CHECKPOINT:
            mutationPayload = applySwitchToLatestOfferCommand_1.applySwitchToLatestOffer(command, user, content, states, enrolments);
            break;
        case entity_1.ContentType.CURRICULUM:
            mutationPayload = applySwitchToLatestCurriculumOfferCommand_1.applySwitchToLatestCurriculumOffer(command, user, content, childContents, states, enrolments);
            break;
        default:
            mutationPayload = {
                events: [],
                states,
                stateInteractions: [],
                enrolments
            };
            break;
    }
    return mutationPayload;
}
exports.applySwitchToLatestContentCommand = applySwitchToLatestContentCommand;
//# sourceMappingURL=index.js.map